import React, { useContext, useMemo } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Context } from "../../Context/ContextApi";

const FeaturedPaintings = () => {
  const { featuredPaintings, loading } = useContext(Context);

  const featuredPaintingsData = useMemo(
    () => featuredPaintings?.data?.data ?? [],
    [featuredPaintings]
  );

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="container-fluid mt-4 featured-paintings">
      <h1 className="text-center mb-3">Our Featured Paintings</h1>

      {loading || !featuredPaintingsData.length ? (
        <div className="featured-skeleton text-center text-muted py-5">
          Loading Featured Paintings...
        </div>
      ) : (
        <Slider {...settings}>
          {featuredPaintingsData.map((item) => (
            <div key={item.id} className="painting-box px-3">
              <div className="painting-card">
                <img
                  src={item.painting_image}
                  alt={item.alt_text || item.painting_name}
                  loading="lazy"
                />
                <h3 className="text-center">{item.painting_name}</h3>
              </div>
            </div>
          ))}
        </Slider>
      )}
    </div>
  );
};

export default FeaturedPaintings;
